<template>
  <div class="text-left">
    <DashboardWarning />
    <div class="bg mb-2">
      <h1>{{ $t('pages.dashboards.hr.hello', { name: $auth.user().first_name }) }}</h1>
      <Search />
    </div>
    <div class="bg-card">
      <h1>{{ $t('pages.dashboards.hr.actions') }}</h1>
      <div class="bg-card">
        <h2>
          <router-link
            :to="{ name: 'all-offers' }"
          >
            {{ $t('pages.dashboards.hr.all-offers') }}
          </router-link>
        </h2>
        <h2>
          <router-link
            :to="{ name: 'admin-users' }"
          >
            {{ $t('pages.dashboards.hr.all-users') }}
          </router-link>
        </h2>
        <h2>
          <router-link
            :to="{ name: 'hr-delegations' }"
          >
            {{ $t('pages.dashboards.hr.all-delegations') }}
          </router-link>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Home/Search';
import DashboardWarning from '@/components/DashboardWarning';

export default {
  components: {
    Search,
    DashboardWarning
  }
}
</script>


<style lang="scss" scoped>
  .bg {
    background: url('../../../assets/user-dashboard-search.png');
    padding: 2rem;
  }
</style>
